module.exports = __webpack_public_path__ + "img/mars-en.c44357aa.svg";